<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>DTN Release</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="transmittalForm">
      <div class="row back-row" *ngIf="!isDTNReleased">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <mat-label class="font-weight-bold">Numbering Format : </mat-label>
              <mat-button-toggle-group aria-label="Numbering Format" class="com-semiauto" [value]='numFormat' (change)="onNumFormatChange($event.value)">
                  <mat-button-toggle value="Manual" *ngIf="canManualNo">Manual</mat-button-toggle>
                  <mat-button-toggle value="Semi" aria-checked="true">Semi</mat-button-toggle>
                  <mat-button-toggle value="Auto">Auto</mat-button-toggle>
              </mat-button-toggle-group>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Transmittal No</mat-label>
                  <input matInput formControlName="txtMsgSerialNo" (change)="GenerateDTNManual()" required (keypress)="omit_special_char($event)">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="isShowSerialNo&&!isDTNReleased">
              <mat-form-field>
                  <mat-label>Serial No</mat-label>
                  <input matInput type="number" formControlName="txtSerialNo" required>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <div class="d-flex eip-p-0">
                  <button class="btn btn-primary eip-ml-10 mr-10 eip-mt-10" *ngIf="!messageNo" id="btnGenerateDTN" (click)="GenerateDTN()"><i class="fa fa-process-menu" title="Generate DTN No" aria-hidden="true"></i>&nbsp;&nbsp;
                      Generate DTN No</button>
              </div>
          </div>
      </div>
  </form>
  <div class="row m-0 justify-content-center eip-mt-10" *ngIf="!isDTNReleased">
      <EIPAutoComplete TextField="message_Number" ValueField="message_Id" WaterMarkText="Transmittal No *" formControlName="formDTNList" setId="dtnList" ShowTextValueField='N' [dataSource]='dtnList' [IsCascading]='true' (valueChange)='onDTNValueChange($event,"formDTNList")' [SingleValueBind]="false" [defaultValue]='transmittalNo' [IsDisabled]='transmittalNo'>
      </EIPAutoComplete>
  </div>
  <div class="row m-0 justify-content-center" *ngIf="isShowSerialNo&&!isDTNReleased" style="display: none;">
      <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
  </div>
  <div *ngIf="clear">
      <div class="row m-0 justify-content-center">
          <app-transmittal-view #transmittalViewComponent [transmittalData]="_transmittalData"></app-transmittal-view>
      </div>
      <div style="width: 75%; margin: 0px auto;">
          <div [ngStyle]="setIsShow()">
              <div class="d-flex justify-content-between"><b style="margin-bottom: 1%; margin-left: 1.4%;font-size: 17px;">Delayed Documents</b></div>
              <kendo-grid #dtnGrid #docGrid [kendoGridBinding]="gridData" [pageable]="true" [pageSize]="30" id="respondWorflowLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [scrollable]="true" (mouseover)="onHover($event)" (edit)="editRowData($event)" (cancel)="cancelRowData($event)" (save)="UpdateRowData($event)">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>

                  <kendo-grid-column field="doc_No" title="Document Number" width="50">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.doc_No}}" eipTooltipPosition="auto">
                              {{dataItem.doc_No}}</span>
                      </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column field="revision_No" title="Revision" width="30">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="">
                              {{dataItem.revision_No}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Delay Reason Type" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span eipTooltip="{{dataItem.delayReason}}" eipTooltipPosition="auto">{{dataItem.delayReason}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-column="column" let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div style="width:100%;display:flex">

                              <div style="width:50%; margin-top:2%;">
                                  <EIPAutoComplete TextField="commentType" ValueField="id" WaterMarkText="Delay Reason Type *" ShowTextValueField='N' [SingleValueBind]="false" [dataSource]='delayReasonList' [IsCascading]='true' [defaultValue]="dataItem.selectedDocCommentId" (valueChange)='onselectedValueChange($event,dataItem)'>
                                  </EIPAutoComplete>
                              </div>

                              <div style="width:50%;margin-left:3%;margin-top:2%" *ngIf="dataItem.Doccomment_typeRequired">
                                  <EIPAutoComplete TextField="IntrcommentType" ValueField="id" WaterMarkText="Internal Reason *" ShowTextValueField='N' [SingleValueBind]="false" [dataSource]='internalReasonList' [IsCascading]='true' [defaultValue]="dataItem.setIntrselectedId" (valueChange)='onIntrValueChange($event,dataItem)'>
                                  </EIPAutoComplete>
                              </div>

                              <div style="width:50%;margin-left:3%;margin-top:2%" *ngIf="dataItem.Doccomment_typeRequired == false">
                                  <EIPAutoComplete TextField="ExtrcommentType" ValueField="id" WaterMarkText="External Reason *" ShowTextValueField='N' [SingleValueBind]="false" [dataSource]='externalReasonList' [IsCascading]='true' [defaultValue]="dataItem.setExtrselectedId" (valueChange)='onExtrValueChange($event,dataItem)'>
                                  </EIPAutoComplete>
                              </div>

                              <div style="width:50%;margin-left:3%;margin-top: 2.0%;" *ngIf="dataItem.otherCommentsRequired">
                                  <input matInput type="text" placeholder="Enter Comment" [value]="dataItem.comments" (change)="onValueChange($event,dataItem);" style="border-bottom:1px solid black; margin-top: 2%;padding-top: 2%;" required>
                              </div>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </div>
  </div>
  <div class="row m-0 justify-content-center">
      <button class="btn btn-primary eip-ml-10" id="btnDTNRelease" *ngIf="messageNo&&!isDTNReleased" (click)="dtnRelease()"><i class="fa fa-external-link" title="Release DTN" aria-hidden="true"></i>&nbsp;&nbsp;Release DTN</button>
      <button class="btn btn-primary eip-ml-10" id="btnSendMail" *ngIf="isDTNReleased" (click)="sendMail(true)"><i class="fa fa-consignee-debit-note" title="Send Mail" aria-hidden="true"></i>&nbsp;&nbsp;Send Mail</button>
      <button class="btn btn-secondary eip-ml-10" id="btnSendMail" *ngIf="isDTNReleased" (click)="sendMail(false)"><i class="fa fa-without-fleet" title="Don't Send Mail" aria-hidden="true"></i>&nbsp;&nbsp;Don't Send Mail</button>
  </div>
</div>